export const rdsClearNavMenuHighlight = () => {
  const event = new CustomEvent('rdsSetNavMenuHighlight', {});
  document.dispatchEvent(event);
};
